import React from "react";
import PropTypes from "prop-types";
import MDBox from "shared/ui/Box/MDBox";
import MDTypography from "shared/ui/Typography/MDTypography";

export default function CurrentProgramCard({ title, clientName, hasUnsavedChanges }) {
  return (
    <MDBox sx={{ width: "100%" }}>
      <MDBox
        sx={{
          px: 1.5,
          py: 1.4,
          borderRadius: "10px",
          backgroundColor: "grey.100",
          border: "1px solid",
          borderColor: "grey.300",
          textAlign: "center",
        }}
      >
        <MDTypography
          sx={{
            fontSize: "0.9rem",
            fontWeight: 700,
            lineHeight: 1.3,
            color: title ? "text.primary" : "text.secondary",
            opacity: title ? 1 : 0.7,
            textTransform: "none",
          }}
        >
          {title || "Rutina sin nombre"}
        </MDTypography>

        {clientName ? (
          <MDTypography
            sx={{
              mt: 0.25,
              fontSize: "0.7rem",
              fontWeight: 500,
              color: "text.secondary",
              opacity: 0.85,
            }}
          >
            {clientName}
          </MDTypography>
        ) : (
          <MDTypography
            sx={{
              mt: 0.25,
              fontSize: "0.65rem",
              color: "text.secondary",
              opacity: 0.6,
            }}
          >
            Sin cliente asignado
          </MDTypography>
        )}

        {hasUnsavedChanges !== undefined && (
          <MDTypography
            sx={{
              mt: 0.45,
              fontSize: "0.6rem",
              fontWeight: 500,
              letterSpacing: "0.02em",
              color: hasUnsavedChanges ? "warning.main" : "success.main",
            }}
          >
            Estado: {hasUnsavedChanges ? "cambios sin guardar" : "sin cambios"}
          </MDTypography>
        )}
      </MDBox>

      {/* Separador contextual */}
      <MDBox
        sx={{
          mt: 1.5,
          mb: 0.5,
          height: "1px",
          width: "100%",
          backgroundColor: "grey.300",
        }}
      />
    </MDBox>
  );
}

CurrentProgramCard.propTypes = {
  title: PropTypes.string,
  clientName: PropTypes.string,
  hasUnsavedChanges: PropTypes.bool,
};
